import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M10.578 2.166a3 3 0 0 1 2.844 0l7.5 4.039A3 3 0 0 1 22.5 8.846v10.656a3 3 0 0 1-3 3h-15a3 3 0 0 1-3-3V8.846a3 3 0 0 1 1.578-2.641zM3 12.506v6.996a1.5 1.5 0 0 0 1.5 1.5h15a1.5 1.5 0 0 0 1.5-1.5v-6.995l-.078.043-5.25 2.827 3.434 1.85a.75.75 0 0 1-.712 1.32l-5.683-3.06a1.5 1.5 0 0 0-1.422 0l-5.683 3.06a.75.75 0 1 1-.712-1.32l3.435-1.85-5.251-2.827zm6.91 2.02.668-.36a3 3 0 0 1 2.844 0l.667.36 6.122-3.297A1.5 1.5 0 0 0 21 9.91V8.845a1.5 1.5 0 0 0-.789-1.32l-7.5-4.039a1.5 1.5 0 0 0-1.422 0l-7.5 4.039A1.5 1.5 0 0 0 3 8.846v1.062a1.5 1.5 0 0 0 .789 1.321z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }